var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"vpd-privacy-policy",attrs:{"fluid":""}},[_c('vpd-md-viewer',{attrs:{"source":_vm.source,"title":"Panaszkezelési szabályzat"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }